import Router from '@/router'; 

export function checkSQLerrors(data){	
  
    if (typeof data.sql_errors !== 'undefined'){
        console.log(`%c ${new Date().toLocaleString()}: SQL ERROR `, 'background: red; color: white; font-size:1.2rem;');
        throw 'Invalid SQL';
    }
}

export async function checkAuth(response){

    if (response.status == 200){
        let data = await response.json();
        checkSQLerrors(data);
        return data;
    }

    if (response.status == 403){
        Router.push('/access-denied');
        return
    }

    if (response.status == 401){
        let data = await response.json();
        switch(data.message){
            case 'Token not found.':
                Router.push('/admin/login');
                break;

            case 'page restricted':
                Router.push('/access-denied');
                break;

            case 'not logged in':
                Router.push('/admin/login');
                break;
        }
        
        return;
    }
}

export function formatNumber(number, dp=2){
    if (isNaN(number)){
        number = 0;
    }
    return parseFloat(number).toFixed(dp);
}

export function openModal(modal_id){
    document.getElementById(modal_id).classList.remove('hidden');
}

export function closeModal(modal_id){
    document.getElementById(modal_id).classList.add('hidden');
}

export function generateToken(length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
      counter += 1;
    }
    return result;
}

export function deepCopyObject(object){
    let deep_copy = JSON.parse(JSON.stringify(object));

    return deep_copy;
}

export function setMetaTags(title_tag, description_tag, keywords_tag) {
    const meta_title       = document.querySelector('head title');
    const meta_description = document.querySelector('head meta[name="description"]');
    const meta_keywords    = document.querySelector('head meta[name="keywords"]');

    meta_title.textContent = title_tag;
    meta_description.setAttribute('content', description_tag);
    meta_keywords.setAttribute('content', keywords_tag);
}

export function formatStyles(object){
    let styles = {};

    Object.keys(object).forEach(key => {
        const value = object[key];
        styles[value.css_property] = value.value;
    });
    
    return styles;
}

export function compileStyles(object){
    let styles = {};

    Object.keys(object).forEach(key => {
        const value = object[key];
        styles[value.css_property] = value.value;
    });

    return styles;
}

export function findContainerThatContainsBlocks(containers, block_id){
    let container = {};
    let found = false;

    for (let i = 0; i <containers.length; i++) {
        let current_container = containers[i];

        for (let j = 0; j < current_container.blocks.length; j++) {
            let current_row = current_container.blocks[j];

            if(current_row.id == block_id){
                container = current_container;
                found = true;
                break;
            }
        }

        if(found){
            break;
        }
    }

    return container;
}

export function deleteDynamicCss(stylesheet_id){
    let dynamic_page_custom_css = document.getElementById(stylesheet_id);

    if(dynamic_page_custom_css != null){
        dynamic_page_custom_css.remove();
    }
}

export function importDynamicCss({css = '', stylesheet_id = 'dynamic_page_custom_css', remove_old_css = true, scope_to = '' }={}){
    if(typeof css !== 'undefined'){

        if(remove_old_css){
            let dynamic_page_custom_css = document.getElementById(stylesheet_id);
        
            if(dynamic_page_custom_css != null){
                dynamic_page_custom_css.remove();
            }
        }

        if(scope_to != ''){
            css = `${scope_to}{${css}}`;
        }
    
        let blob = new Blob([css], {type: 'text/css'});
        let link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = window.URL.createObjectURL(blob);
        link.id = stylesheet_id;
    
        let head = document.getElementsByTagName('head')[0];
        head.appendChild(link);
    }
}

export function importFonts(stylesheet_id){ //Google fonts only
    let link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = "https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Exile&family=Playfair+Display:ital,wght@0,400..900;1,400..900&family=Roboto+Condensed:ital,wght@0,100..900;1,100..900&family=Roboto:ital,wght@0,100..900;1,100..900&family=Work+Sans:ital,wght@0,100..900;1,100..900&display=swap";
    link.id = stylesheet_id;

    let head = document.getElementsByTagName('head')[0];
    head.appendChild(link);
}

export function triggerPrerenderEvent(){
    if (window.__PRERENDER_INJECTED){ //For prerender on prod build
        document.dispatchEvent(new Event('prerender-trigger-event')); 
    }
}

export function formatUrlForCachedFiles(url){
    let formatted_url = decodeURIComponent(url).toLowerCase();
    formatted_url     = (formatted_url[0] !== '/') ? '/' + formatted_url : formatted_url;
    formatted_url     = formatted_url.replace(/\/+$/, '');// Remove trailing slash
    formatted_url     = formatted_url.replace(/[^a-zA-Z0-9-\/]+/g,"-").replaceAll('/', '__'); //Replace all nonalphanumeric chars
    return formatted_url;
}

export function sanitizeSlug(input) {
    // Decode HTML entities like &#233; to é
    const textarea = document.createElement('textarea');
    textarea.innerHTML = input;
    let str = textarea.value;

    // Convert to lowercase
    str = str.toLowerCase();

    // Manual transliteration (replace accented characters)
    const translitMap = {
        'ü': 'u', 'Ü': 'u', 'é': 'e', 'ã': 'a',
        'Ä': 'a', 'ä': 'a', 'Ö': 'o', 'ö': 'o',
        'ê': 'e', 'è': 'e', 'ô': 'o', 'ó': 'o', 'ú': 'u',
    };
    str = str.replace(/./g, char => translitMap[char] || char);

    // Replace all non-alphanumeric characters with space
    str = str.replace(/[^a-z0-9]+/g, ' ');

    // Replace whitespace with dashes
    str = str.replace(/\s+/g, '-');

    // Replace multiple dashes with one
    str = str.replace(/-+/g, '-');

    // Trim leading/trailing dashes
    str = str.replace(/^-+|-+$/g, '');

    return str;
}
